export interface CreditCardInfo {
  id: string;
  object: string;
  address_city: string;
  address_country: string;
  address_line1: string;
  address_line1_check: string;
  address_line2: string;
  address_state: string;
  address_zip: string;
  address_zip_check: string;
  brand: CardType | string;
  label: string;
  type: string;
  walletType: string | null;
  isChargeable: boolean;
  country: string | null;
  customer: string;
  cvc_check: string;
  dynamic_last4: number;
  exp_month: number | null;
  exp_year: number | null;
  fingerprint: string;
  funding: string;
  last4: string | null;
  metadata: CardMetadata;
  name: string;
  tokenization_method: string;
  isValid: boolean;
  isDefault: boolean;
  creditCardId: string;
}

export enum CardType {
  Visa = 'Visa',
  AmericanExpress = 'American Express',
  Amex = 'Amex',
  Diners = 'Diners',
  DinersClub = 'Diners Club',
  Discover = 'Discover',
  JCB = 'JCB',
  MasterCard = 'MasterCard',
  UnionPay = 'UnionPay',
  Unknown = 'Unknown',
}

export interface CardMetadata {}
